import axios from "axios";
import { AdminMessage } from "../entities/formTemplateDataType";

export const getEnvConfig = () => {
    if (!process.env) {
        return undefined;
    }
    const result = {
        ENV: process.env.ENV,
        PUBLIC_URL: process.env.PUBLIC_URL,
        Path: process.env.Path,
        LoginCallbackUrl: process.env.LoginCallbackUrl,
        IS_RUNTIME: !!process.env.IS_RUNTIME,
        LAYOUT_API_URL: process.env.LAYOUT_API_URL,
        ISSUER: process.env.ISSUER,
        CLIENT_ID: process.env.CLIENT_ID,
        BASE_URI: process.env.BASE_URI,
        REDIRE_URL: process.env.REDIRE_URL,
        RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
        SUBMIT_URL: process.env.SUBMIT_URL,
    };

    //console.log(`runtiime config: ${JSON.stringify(result, null, 2)}`);
    return result;
}

export const getAdminConfig = async (appName?: string) => {
    if (process.env.MaintenanceMode === 'true') {
        return { 
            messageContent: 'The system is currently under maintenance. Please try again later.',
            messageType: 'Maintenance',
            messageContentFrench: 'Le système est actuellement en maintenance. Veuillez réessayer plus tard.',
            isActive: true,
            fromTime: '2025-03-03T20:00:00',
            toTime: '2025-03-04T20:00:00',
         };
    }

    const adminUrl = `${process.env.ADMIN_SERVICE_API_URL}/${appName}`;
    try {
        const response = await axios.get<{data?: AdminMessage; message?: string; status?: string;}>(adminUrl, {
            headers: { 
                'X-API-Key': process.env.ADMIN_SERVICE_API_KEY,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-Requested-With',
            },
        });

        if (response.status !== 200) {
            return undefined;
        }
        return response.data?.data;
    } catch (error) {
        console.error("Error fetching CXP profile:", error.response?.data || error.message);
        return undefined;
    }
}